/* eslint-disable no-magic-numbers */
export const TENANTS = [
  'tigerair',
  'veloair',
] as const;

export type TenantI18nName = typeof TENANTS[number];

/** 0 is Sunday */
export type StartOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export const FIRST_DAY_OF_WEEK: Record<string, StartOfWeek> = {
  'en-US': 0,
  'es-ES': 1,
  'zh-CN': 1,
  'zh-TW': 1,
  'ar-SA': 6,
};